module.exports = __webpack_public_path__ + "static/media/WaywardCreaturesBookCover.d34457f9.jpg";